module.exports = __webpack_public_path__ + "images/interview-Optum-2.svg";